import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { SalesCampaignPageInitialData } from "./salesCampaignPageInitialData";

export const salesCampaignPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("campaign"),
    queryFn: () => fetchOccPageData<PageInitialDataResult<SalesCampaignPageInitialData>>("/page-data/campaign"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
